const menu = () => {
  const trigger = $('.hamburger');
  const mobileNav = $('.mobile.site-nav');
  const header = $('.site-header');
  const openIcon = $('.open-icon');
  const closeIcon = $('.close-icon');
  trigger.click(function() {
    if (trigger.hasClass('is-open')) {
      header.removeClass('menu-open');
      trigger.removeClass('is-open');
      mobileNav.addClass('hidden');
      openIcon.removeClass('hidden');
      closeIcon.addClass('hidden');
    } else {
      header.addClass('menu-open');
      trigger.addClass('is-open');
      mobileNav.removeClass('hidden');
      openIcon.addClass('hidden');
      closeIcon.removeClass('hidden');
    }
  });
};
export default menu;